export default __webpack_public_path__ + "static/media/607.9261bf2b.gif";